import Grid from '@mui/material/Grid2';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import OriginAndDestinationTableViewModel from '../../ViewModels/OriginAndDestinationTableViewModel';

interface SurveyTableProps {
    survey: OriginAndDestinationTableViewModel;
}

interface TableSectionProps {
    title: string;
    data: {
        originOrDestination: string;
        frequency: number;
    }[];
}

const TableSection = ({ title, data }: TableSectionProps) => (
    <Grid size={6}>
    <Typography variant="h6">{title}</Typography>
        <TableContainer>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Post Code (First Part)</TableCell>
                        <TableCell>Frequency</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data && data.map((item, index) => (
                        <TableRow key={index + title}>
                            <TableCell>{item.originOrDestination}</TableCell>
                            <TableCell>{item.frequency}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    </Grid>
);

export default function OriginAndDestinationTable({ survey }: SurveyTableProps) {
    return (
        <>
            {survey &&
                <>
                    <TableSection title="Origins" data={survey.origins} />
                    <TableSection title="Destinations" data={survey.destinations} />
                </>
            }
        </>
    );
}
